module.exports = __webpack_public_path__ + "static/img/tax-day.c242479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tax-day.jpg
// module id = R8+p
// module chunks = 1